import { MEDICAL_VISIT_PRESET_COUNTRIES } from '@geartracker/types';

import { createZodDto } from './zod';

import { z } from 'zod';

export const UpdateMedicalVisitConfigSchema = z.object({
  medicalVisitTrackingEnabled: z.boolean(),
  // Provided + org has zero MedicalVisitType yet => generates the preset
  // catalog for that country. Omitted/null: no generation (either "Autre
  // pays" was picked, or the org already has types).
  country: z.enum(MEDICAL_VISIT_PRESET_COUNTRIES).nullable().optional(),
});

export class MedicalVisitConfigUpdateDto extends createZodDto(
  UpdateMedicalVisitConfigSchema,
) {}
